import { render, staticRenderFns } from "./videoComponent.vue?vue&type=template&id=0b2d5950&scoped=true"
import script from "./videoComponent.vue?vue&type=script&lang=js"
export * from "./videoComponent.vue?vue&type=script&lang=js"
import style0 from "./videoComponent.vue?vue&type=style&index=0&id=0b2d5950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d5950",
  null
  
)

export default component.exports